import * as React from 'react';

function SvgStar(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 23.89 22.97" focusable={false} role="presentation" aria-hidden={true} {...props}>
      <path d="M23.95 8.9a1.05 1.05 0 01-.38.7l-5.21 5.12L19.55 22a2.27 2.27 0 010 .29.85.85 0 01-.15.51.51.51 0 01-.45.2 1.09 1.09 0 01-.57-.17l-6.43-3.45L5.5 22.8a1.15 1.15 0 01-.55.2.52.52 0 01-.45-.21.85.85 0 01-.15-.51 2.32 2.32 0 010-.29l1.23-7.24L.36 9.6A1.1 1.1 0 010 8.9c0-.35.27-.58.81-.66l7.21-1.06L11.25.59c.18-.39.41-.59.7-.59s.52.2.7.59l3.24 6.59 7.2 1.06c.54.08.86.31.86.66z" />
    </svg>
  );
}

const MemoSvgStar = React.memo(SvgStar);
export default MemoSvgStar;
